// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-value {\n  display: flex;\n  flex-flow: column;\n  color: var(--primary-color);\n  font-size: 1.4rem;\n}\n.title-value__title {\n  font-weight: bold;\n  padding-bottom: 1rem;\n}\n.title-value__value {\n  padding-bottom: 0.5rem;\n}\n.title-value__value--capitalize {\n  text-transform: capitalize;\n}\n", ""]);
// Exports
module.exports = exports;
